var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("pdf-layout " + (_vm.className || ''))},[(_vm.flag)?_c('pdf',{attrs:{"src":_vm.src,"page":_vm.page},on:{"loaded":_vm.loaded,"page-loaded":_vm.pageLoaded,"link-clicked":_vm.linkClicked,"error":_vm.error}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }